<template>
  <div class="tab-content">
    <h4 class="section-title">Berkas Pendukung</h4>

    <div class="form-fields">
      <div class="field">
        <label>PERKI Cabang <span class="required">*</span></label>
        <div class="field-value">{{ data.perkiCabang }}</div>
      </div>

      <div class="field">
        <label>Surat Rekomendasi PERKI Cabang <span class="required">*</span></label>
        <div v-if="isImage(data.fileSuratRekomendasi)" class="image-preview-row">
          <img :src="getFileUrl(data.fileSuratRekomendasi)" class="img-preview landscape" alt="Surat Rekomendasi" @error="onImgError" />
          <div class="image-actions">
            <button class="btn-file-outline" @click="handleLihat(data.fileSuratRekomendasi)"><i class="fe fe-eye" /> Lihat</button>
            <button class="btn-file-filled" @click="handleUnduh(data.fileSuratRekomendasi)"><i class="fe fe-download" /> Unduh</button>
          </div>
        </div>
        <div v-else class="file-row">
          <div class="field-value file-name">{{ getFileName(data.fileSuratRekomendasi) }}</div>
          <button class="btn-file-outline" :disabled="!data.fileSuratRekomendasi" @click="handleLihat(data.fileSuratRekomendasi)"><i class="fe fe-eye" /> Lihat</button>
          <button class="btn-file-filled" :disabled="!data.fileSuratRekomendasi" @click="handleUnduh(data.fileSuratRekomendasi)"><i class="fe fe-download" /> Unduh</button>
        </div>
      </div>

      <div class="field">
        <label>Ijazah Dokter Spesialis / Sertifikat Profesi <span class="required">*</span></label>
        <div v-if="isImage(data.fileIjazah)" class="image-preview-row">
          <img :src="getFileUrl(data.fileIjazah)" class="img-preview landscape" alt="Ijazah" @error="onImgError" />
          <div class="image-actions">
            <button class="btn-file-outline" @click="handleLihat(data.fileIjazah)"><i class="fe fe-eye" /> Lihat</button>
            <button class="btn-file-filled" @click="handleUnduh(data.fileIjazah)"><i class="fe fe-download" /> Unduh</button>
          </div>
        </div>
        <div v-else class="file-row">
          <div class="field-value file-name">{{ getFileName(data.fileIjazah) }}</div>
          <button class="btn-file-outline" :disabled="!data.fileIjazah" @click="handleLihat(data.fileIjazah)"><i class="fe fe-eye" /> Lihat</button>
          <button class="btn-file-filled" :disabled="!data.fileIjazah" @click="handleUnduh(data.fileIjazah)"><i class="fe fe-download" /> Unduh</button>
        </div>
      </div>

      <div class="field">
        <label>Surat Keterangan <span class="required">*</span></label>
        <div v-if="isImage(data.fileSuratKeterangan)" class="image-preview-row">
          <img :src="getFileUrl(data.fileSuratKeterangan)" class="img-preview landscape" alt="Surat Keterangan" @error="onImgError" />
          <div class="image-actions">
            <button class="btn-file-outline" @click="handleLihat(data.fileSuratKeterangan)"><i class="fe fe-eye" /> Lihat</button>
            <button class="btn-file-filled" @click="handleUnduh(data.fileSuratKeterangan)"><i class="fe fe-download" /> Unduh</button>
          </div>
        </div>
        <div v-else class="file-row">
          <div class="field-value file-name">{{ getFileName(data.fileSuratKeterangan) }}</div>
          <button class="btn-file-outline" :disabled="!data.fileSuratKeterangan" @click="handleLihat(data.fileSuratKeterangan)"><i class="fe fe-eye" /> Lihat</button>
          <button class="btn-file-filled" :disabled="!data.fileSuratKeterangan" @click="handleUnduh(data.fileSuratKeterangan)"><i class="fe fe-download" /> Unduh</button>
        </div>
      </div>

      <div class="field">
        <label>Pas Foto Warna Terbaru <span class="required">*</span></label>
        <div class="image-preview-row">
          <img v-if="data.filePasFoto" :src="getFileUrl(data.filePasFoto)" class="img-preview portrait" alt="Pas Foto" @error="onImgError" />
          <div v-else class="img-placeholder portrait"></div>
          <div class="image-actions">
            <button class="btn-file-outline" :disabled="!data.filePasFoto" @click="handleLihat(data.filePasFoto)"><i class="fe fe-eye" /> Lihat</button>
            <button class="btn-file-filled" :disabled="!data.filePasFoto" @click="handleUnduh(data.filePasFoto)"><i class="fe fe-download" /> Unduh</button>
          </div>
        </div>
      </div>

      <div class="field">
        <label>Foto Profil Formal <span class="required">*</span></label>
        <div class="image-preview-row">
          <img v-if="data.fileFotoProfil" :src="getFileUrl(data.fileFotoProfil)" class="img-preview square" alt="Foto Profil" @error="onImgError" />
          <div v-else class="img-placeholder square"></div>
          <div class="image-actions">
            <button class="btn-file-outline" :disabled="!data.fileFotoProfil" @click="handleLihat(data.fileFotoProfil)"><i class="fe fe-eye" /> Lihat</button>
            <button class="btn-file-filled" :disabled="!data.fileFotoProfil" @click="handleUnduh(data.fileFotoProfil)"><i class="fe fe-download" /> Unduh</button>
          </div>
        </div>
      </div>

      <div class="field">
        <label>Lampiran Persetujuan</label>
        <div v-if="isImage(data.fileLampiranPersetujuan)" class="image-preview-row">
          <img :src="getFileUrl(data.fileLampiranPersetujuan)" class="img-preview landscape" alt="Lampiran Persetujuan" @error="onImgError" />
          <div class="image-actions">
            <button class="btn-file-outline" @click="handleLihat(data.fileLampiranPersetujuan)"><i class="fe fe-eye" /> Lihat</button>
            <button class="btn-file-filled" @click="handleUnduh(data.fileLampiranPersetujuan)"><i class="fe fe-download" /> Unduh</button>
          </div>
        </div>
        <div v-else class="file-row">
          <div class="field-value file-name">{{ getFileName(data.fileLampiranPersetujuan) }}</div>
          <button class="btn-file-outline" :disabled="!data.fileLampiranPersetujuan" @click="handleLihat(data.fileLampiranPersetujuan)"><i class="fe fe-eye" /> Lihat</button>
          <button class="btn-file-filled" :disabled="!data.fileLampiranPersetujuan" @click="handleUnduh(data.fileLampiranPersetujuan)"><i class="fe fe-download" /> Unduh</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const FILES_BASE_URL = process.env.VUE_APP_PERKI_FILES_URL || 'http://localhost:3000/files'

export default {
  name: 'MemberApplicationTabBerkasPendukung',
  props: {
    data: { type: Object, required: true },
  },
  methods: {
    getFileUrl(path) {
      if (!path) return ''
      if (path.startsWith('http')) return path
      return `${FILES_BASE_URL}/membership-apps/${path}`
    },
    getFileName(path) {
      if (!path) return '-'
      return path.split('/').pop()
    },
    isImage(path) {
      if (!path) return false
      const ext = path.split('.').pop().toLowerCase()
      return ['jpg', 'jpeg', 'png'].includes(ext)
    },
    handleLihat(path) {
      if (!path) return
      window.open(this.getFileUrl(path), '_blank')
    },
    async handleUnduh(path) {
      if (!path) return
      const url = this.getFileUrl(path)
      const filename = this.getFileName(path)
      try {
        const res = await fetch(url)
        const blob = await res.blob()
        const blobUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = blobUrl
        a.download = filename
        a.click()
        URL.revokeObjectURL(blobUrl)
      } catch {
        // fallback: buka di tab baru
        window.open(url, '_blank')
      }
    },
    onImgError(e) {
      e.target.style.display = 'none'
    },
  },
}
</script>

<style scoped>
.tab-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-title {
  font-size: 20px;
  font-weight: 700;
  color: #282828;
  margin: 0;
}

.form-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field label {
  font-size: 14px;
  font-weight: 700;
  color: #444;
}

.required {
  color: #dc3545;
}

.field-value {
  background: #e4e9f0;
  border: 1px solid #e4e9f0;
  border-radius: 6px;
  padding: 4px 16px;
  min-height: 32px;
  font-size: 14px;
  color: #444;
  line-height: 22px;
  display: flex;
  align-items: center;
}

.file-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.file-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.btn-file-outline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 50px;
  border: 2px solid #282828;
  background: #fff;
  color: #282828;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

.btn-file-outline:disabled {
  border-color: #ccc;
  color: #ccc;
  cursor: not-allowed;
}

.btn-file-filled {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 50px;
  border: 2px solid #282828;
  background: #282828;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

.btn-file-filled:disabled {
  border-color: #ccc;
  background: #ccc;
  cursor: not-allowed;
}

.image-preview-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.img-preview {
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #e4e9f0;
}

.img-preview.portrait {
  width: 100px;
  height: 133px;
}

.img-preview.square {
  width: 100px;
  height: 100px;
}

.img-preview.landscape {
  width: 160px;
  height: 120px;
}

.img-placeholder {
  background: #e4e9f0;
  border-radius: 4px;
  border: 1px solid #d0d7e0;
}

.img-placeholder.portrait {
  width: 100px;
  height: 133px;
}

.img-placeholder.square {
  width: 100px;
  height: 100px;
}

.image-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}
</style>
